import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { hostListQueries } from '@/services/hostManagement/hostManagement.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useHostMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('toggleHostStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...hostListQueries.all()] });
      toast.success(res.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutate: mutateAsync };
};

export default useHostMutation;
